import React, { useState } from 'react';
import {
    Button,
    IconButton,
    Typography,
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box
} from '@mui/material';
import { Cancel } from '@mui/icons-material';
import PropTypes from 'prop-types';

function DriverColumn({ value, tableMeta, updateValue, unsetDriverWearable }) {
    // open dialog
    const [open, setOpen] = useState(false);
    return (
        <Box>
            {value?.uuid && (
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Typography variant="body2">{value?.uuid}</Typography>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={() => setOpen(true)}>
                            <Cancel />
                        </IconButton>
                        <Dialog
                            open={open}
                            onClose={() => setOpen(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title" component="div">
                                <Typography variant="h4">Unset Driver</Typography>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to unset the driver from wearable?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpen(false)} color="primary">
                                    No
                                </Button>
                                <Button
                                    onClick={async () => {
                                        unsetDriverWearable(tableMeta, value.uuid, updateValue).then(() => {
                                            setOpen(false);
                                        });
                                    }}
                                    color="primary"
                                    autoFocus
                                >
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Grid>
            )}
        </Box>
    );
}

DriverColumn.propTypes = {
    value: PropTypes.object,
    tableMeta: PropTypes.object.isRequired,
    updateValue: PropTypes.func,
    unsetDriverWearable: PropTypes.func.isRequired
};

export default DriverColumn;
